import React from "react"
import { Header, Footer } from "./components"
import BookingForm from "@/components/BookingForm"

interface WebTTMIProps {
  children: React.ReactNode
}

const WebTTMI: React.FC<WebTTMIProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <BookingForm />
      <main className="flex-grow">{children}</main>
      {/* <Footer /> */}

      {/* Floating Action Buttons */}
      <div className="fixed bottom-6 right-4 z-[60] flex flex-col items-center gap-3">
        {/* Messenger */}
        <a
          href="https://www.facebook.com/3t.nguyenlieu/?locale=vi_VN"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Liên hệ Messenger"
          className="group w-12 h-12 rounded-full bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110 flex items-center justify-center overflow-hidden"
        >
          <img
            src="/messenger.png"
            alt="Messenger"
            className="w-12 h-12 object-cover"
            loading="lazy"
          />
        </a>

        {/* Zalo */}
        <a
          href="https://id.zalo.me/account?continue=http%3A%2F%2Fzalo.me%2F0913173838"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Liên hệ Zalo"
          className="group w-12 h-12 rounded-full bg-white shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110 flex items-center justify-center overflow-hidden"
        >
          <img
            src="/zalo.jpg"
            alt="Zalo"
            className="w-12 h-12 object-cover"
            loading="lazy"
          />
        </a>
      </div>
    </div>
  )
}

export default WebTTMI
